import { render, staticRenderFns } from "./ImportSellerQuotation.vue?vue&type=template&id=24d456e2&scoped=true&"
import script from "./ImportSellerQuotation.vue?vue&type=script&lang=js&"
export * from "./ImportSellerQuotation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24d456e2",
  null
  
)

export default component.exports